import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routing from "./routing/Routing";
import { Toaster } from "react-hot-toast";
import { GlobalProvider } from "./context/GlobalContext";

function App() {
  return (
    <>
      <GlobalProvider>
        <Toaster position="top-right" reverseOrder={false} />
        <BrowserRouter>
          <Routing />
        </BrowserRouter>
      </GlobalProvider>
    </>
  );
}

export default App;
